
const $ = require('rgs-jquery');

const PromiseQueue = require('./promise-queue.js');


// BUG: It can be observed that this queue does not execute the last `enqueue`d item

function SinglePromiseQueue () {
	/*
	 * Queue of length 1. Older items will be dropped from the queue.
	 */

	if (!(this instanceof SinglePromiseQueue)) {
		return new SinglePromiseQueue();
	}

	PromiseQueue.apply(this, arguments);

	return this;
}

SinglePromiseQueue.prototype = $.extend(Object.create(PromiseQueue.prototype), {
	enqueue: function (taskFunction) {
		/*
		 * Adds a task to the queue. If the queue is empty, task will be
		 * called immediately, otherwise the task will be called once
		 * currently running task ends (resolved or rejected)
		 *
		 * `taskFunction` must return a promise.
		 *
		 * Returns a promise which
		 *  * will be resolved when the `taskFunction`'s promise is
		 *	resolved or rejected
		 *  * will be rejected if the `taskFunction` was dropped
		 */

		const oldLength = this._queue.length;

		const dfr = $.Deferred();
		this._queue.unshift({
			task: taskFunction,
			dfr: dfr,
		});

		while (this._queue.length > 1) {
			const item = this._queue.shift();
			item.dfr.reject(new Error('DroppedBySinglePromiseQueue'));
		}

		if (!oldLength && !this._running) {
			this._dequeue();
		}

		return dfr.promise();
	},
});


module.exports = SinglePromiseQueue;

